import React, {
    createContext,
    ReactNode,
    useCallback,
    useMemo,
    useState,
} from "react";

interface State {
    closeModalHapusWarehouse: () => void;
    idWarehouse: number | undefined;
    isOpenModalHapusWarehouse: boolean;
    namaWarehouse: string;
    openModalHapusWarehouse: (id: number | undefined, nama: string) => void;
}

interface IHapusWarehouseModalContext {
    children: ReactNode;
}

const HapusWarehouseModalContext = createContext<State | undefined>(undefined);

const HapusWarehouseModalProvider = ({
    children,
}: IHapusWarehouseModalContext) => {
    const [isOpenModalHapusWarehouse, setIsOpenModalHapusWarehouse] =
        useState(false);
    const [idWarehouse, setIdWarehouse] = useState<number | undefined>();
    const [namaWarehouse, setNamaWarehouse] = useState("");

    const openModalHapusWarehouse = useCallback(
        (id: number | undefined, nama: string) => {
            setIdWarehouse(id);
            setNamaWarehouse(nama);
            setIsOpenModalHapusWarehouse(true);
        },
        [],
    );

    const closeModalHapusWarehouse = useCallback(() => {
        setIsOpenModalHapusWarehouse(false);
    }, []);

    const value = useMemo(
        () => ({
            closeModalHapusWarehouse,
            idWarehouse,
            isOpenModalHapusWarehouse,
            namaWarehouse,
            openModalHapusWarehouse,
        }),
        [
            closeModalHapusWarehouse,
            idWarehouse,
            isOpenModalHapusWarehouse,
            namaWarehouse,
            openModalHapusWarehouse,
        ],
    );
    return (
        <HapusWarehouseModalContext.Provider value={value}>
            {children}
        </HapusWarehouseModalContext.Provider>
    );
};

const useHapusWarehouseModal = () => {
    const context = React.useContext(HapusWarehouseModalContext);
    if (context === undefined) {
        throw new Error(
            "useHapusWarehouseModal must be used within a HapusWarehouseModalProvider",
        );
    }
    return context;
};

export {
    HapusWarehouseModalContext,
    HapusWarehouseModalProvider,
    useHapusWarehouseModal,
};
